import React, { useContext } from "react";
import { Slide, Paper, Box, IconButton } from "@mui/material";
import PropTypes from "prop-types";
import { useTheme } from "@mui/material/styles";
import makeStyles from "@mui/styles/makeStyles";
import { withRouter } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";
import clsx from "clsx";
import AdminView from "./AdminView";
import LearnerView from "./LearnerView";
import { updateUserSettings } from "../../services/temporaryVisionCallService";
import { makeGetEntities } from "../../redux/selectors/selectors";
import { useSelector } from "react-redux";
import AppContext from "../../context/AppContext";
import { sortBy } from "lodash";

const selector = makeGetEntities();

const useStyles = makeStyles(theme => ({
  root: theme.mixins.slideOutContainer,
  paper: theme.mixins.slideOut,
  closeButton: {
    position: "absolute",
    top: `calc(${theme.sizes.topNavBarHeight}px +  ${theme.spacing(4)})`,
    right: theme.spacing(4),
    zIndex: 4
  },
  closeButtonIcon: {
    height: 14,
    width: 14
  },
  contrastIcon: {
    color: theme.palette.common.white
  }
}));

function WelcomeSlideOutContent(props) {
  if (props.adminView) {
    return <AdminView {...props} />;
  } else {
    return <LearnerView {...props} />;
  }
}

function WelcomeSlideOut(props) {
  const classes = useStyles();
  const theme = useTheme();

  const { welcomeSlideOutOpen, setWelcomeSlideOutOpen } = useContext(
    AppContext
  );

  const { todoListLoading, todoList } = useSelector(
    ({ todoState, userAssignmentsListState }) => ({
      todoListLoading: todoState.loading,
      todoList: sortBy(
        selector(
          { ...userAssignmentsListState, ...todoState },
          {
            type: "toDo"
          }
        ),
        "order"
      )
    })
  );

  function handleSlideOutClose() {
    // TODO: We need to re-evaluate this. See https://grace-hill.slack.com/archives/GLZ5TFG7Q/p1576700306008300
    // for context. How do we handle dialogs?
    setWelcomeSlideOutOpen(false);
    return updateUserSettings(props.currentUser.id, { show_banner: false });
  }
  return (
    <Box className={classes.root}>
      {props.currentUser.settings && props.currentUser.settings.show_banner && (
        <Slide
          direction="right"
          in={welcomeSlideOutOpen}
          mountOnEnter
          unmountOnExit
        >
          <Paper className={classes.paper}>
            <Box width={{ xs: "100vw", sm: theme.sizes.slideOutWidth }}>
              <IconButton
                size="small"
                className={clsx({ [classes.contrastIcon]: props.banner })}
                classes={{
                  label: classes.closeButtonIcon,
                  root: classes.closeButton
                }}
                onClick={handleSlideOutClose}
                data-qa="welcome-slide-out-close"
              >
                <CloseIcon />
              </IconButton>
              <WelcomeSlideOutContent
                {...props}
                todoList={todoList ? todoList : []}
                fetchTodos={props.fetchTodos}
                todoListLoading={todoListLoading}
                handleSlideOutClose={handleSlideOutClose}
              />
            </Box>
          </Paper>
        </Slide>
      )}
    </Box>
  );
}

export default withRouter(WelcomeSlideOut);

WelcomeSlideOut.propTypes = {
  /**
   * True if the welcome slide should be presented in the admin view, false for learner
   */
  adminView: PropTypes.bool,
  /**
   * Object containing data for the banner in the admin view
   */
  banner: PropTypes.any,
  /**
   * The title for the welcome slide
   */
  title: PropTypes.string,
  /**
   * The description under the title
   */
  content: PropTypes.string,
  /**
   * Contains the link to the video to be shown in the welcome slide
   */
  videoUrl: PropTypes.string
};
